<template>
  <Dialog :open="isOpen" class="relative z-50 bg-white">
    <div class="fixed inset-0 bg-[#191919B2]"></div>
    <div class="fixed inset-0 flex w-screen items-center justify-center p-4">
      <DialogPanel
        class="w-full max-w-sm rounded-[8px] bg-white relative"
        :class="{ 'pt-[32px]': dialogConfig?.imagePosition === 'padded' }"
        data-testid="uiDialog"
      >
        <template v-if="dialogConfig?.image">
          <img
            v-if="typeof dialogConfig.image === 'string'"
            class="rounded-t-[8px] w-full"
            :src="dialogConfig.image"
          />
          <Component v-else :is="dialogConfig.image" class="rounded-t-[8px] w-full" />
        </template>

        <div class="flex flex-col p-[32px] gap-[16px]">
          <div
            class="font-roboto text-[18px] font-[700] leading-[21px] text-center"
            v-if="dialogConfig?.title"
          >
            {{ dialogConfig.title }}
          </div>
          <template v-if="dialogConfig?.text !== undefined">
            <div
              class="font-roboto text-[14px] font-[400] leading-[22px] text-center text-[#00000099]"
              v-if="typeof dialogConfig.text === 'string'"
            >
              {{ dialogConfig.text }}
            </div>
            <Component :is="dialogConfig.text" v-else />
          </template>
          <UiButton
            data-testid="primaryButton"
            @click="dialogStore.onPrimaryButtonClick()"
            v-if="dialogConfig?.primaryButtonText"
            >{{ dialogConfig.primaryButtonText }}</UiButton
          >
          <UiButton
            data-testid="secondaryButton"
            @click="dialogStore.onSecondaryButtonClick()"
            flat
            v-if="dialogConfig?.secondaryButtonText"
            >{{ dialogConfig.secondaryButtonText }}</UiButton
          >
        </div>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel } from '@headlessui/vue'
import UiButton from './button/UiButton.vue'
import { useUiDialogStore } from '@/stores/uiDialog'
import { computed } from 'vue'

const dialogStore = useUiDialogStore()

const isOpen = computed(() => dialogStore.isOpen)
const dialogConfig = computed(() => dialogStore.openedDialogConfig)
</script>
